const ExclamationMarkCircleIcon = (props: any) => {
  const {
    insideFill,
    size = '120',
    circleFill = '#FFF3E5',
    fill = '#344054',
    ...otherProps
  } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...otherProps}
    >
      <rect width='120' height='120' rx='60' fill={circleFill} />
      <path
        d='M61.894 25.0146H57.7847C54.9458 25.0146 52.6764 27.3756 52.7887 30.2123L54.6174 76.4343C54.6989 78.4953 56.3934 80.124 58.456 80.124C60.4304 80.124 62.0833 78.6274 62.2787 76.6627L66.8694 30.5095C67.1621 27.567 64.8511 25.0146 61.894 25.0146Z'
        fill={fill}
      />
      <path
        d='M54.4013 89.9688C54.4644 88.9124 55.3395 88.0879 56.3978 88.0879H60.4668C61.5714 88.0879 62.4668 88.9833 62.4668 90.0879V93.8428C62.4668 94.8625 61.6996 95.7189 60.6861 95.8307L56.3647 96.3074C55.1328 96.4433 54.0752 95.4375 54.149 94.2004L54.4013 89.9688Z'
        fill={fill}
      />
    </svg>
  );
};

export default ExclamationMarkCircleIcon;
